"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTagPhotographersProperty = exports.tagPhotographersPropertyDefinition = void 0;
exports.tagPhotographersPropertyDefinition = {
    name: 'tag-photographers',
    type: 'asset',
    multiple: true,
    view: {
        hint: 'Related to a photographer? Tag it and the asset shows on the photographer collection page.',
        label: 'Photographers',
        style: '',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['photographer'],
        },
    ],
};
const isTagPhotographersProperty = (prop) => {
    return prop.name === exports.tagPhotographersPropertyDefinition.name;
};
exports.isTagPhotographersProperty = isTagPhotographersProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGFnLXBob3RvZ3JhcGhlcnMucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy90YWctcGhvdG9ncmFwaGVycy5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGtDQUFrQyxHQUFHO0lBQ2hELElBQUksRUFBRSxtQkFBbUI7SUFDekIsSUFBSSxFQUFFLE9BQU87SUFDYixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRTtRQUNKLElBQUksRUFBRSw0RkFBNEY7UUFDbEcsS0FBSyxFQUFFLGVBQWU7UUFDdEIsS0FBSyxFQUFFLEVBQUU7S0FDVjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsY0FBYyxDQUFDO1NBQzNCO0tBQ0Y7Q0FDOEIsQ0FBQTtBQUkxQixNQUFNLDBCQUEwQixHQUFHLENBQUMsSUFBa0IsRUFBb0MsRUFBRTtJQUNqRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssMENBQWtDLENBQUMsSUFBSSxDQUFBO0FBQzlELENBQUMsQ0FBQTtBQUZZLFFBQUEsMEJBQTBCLDhCQUV0QyJ9